import React, { Children, useEffect, useRef, } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import generateID from "../../../utils/string-utils";
var NavItem = function (props) {
    var 
    // @ts-ignore
    className = props.className, children = props.children, label = props.label, id = props.id, _a = props.megaMenu, megaMenu = _a === void 0 ? false : _a, 
    // @ts-ignore
    __TYPE = props.__TYPE;
    var _classNames = classNames(className, __TYPE, "fr-nav__item");
    var navItemHeader = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "NavItemHeader";
    });
    var navItemBody = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "NavItemBody";
    });
    var navLink = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "NavLink";
    });
    var getActive = function (e) {
        var elements = document.querySelectorAll(".fr-nav__link");
        elements.forEach(function (element) {
            if (e.target === element) {
                element.setAttribute("aria-current", "page");
            }
            else {
                element.removeAttribute("aria-current");
            }
        });
    };
    var itExpands = function (e) {
        var buttons = document.querySelectorAll(".fr-nav__btn");
        buttons.forEach(function (button) {
            if (e.target === button &&
                (button.getAttribute("aria-expanded") === null ||
                    button.getAttribute("aria-expanded") === "false")) {
                var d = document.getElementById("".concat(button.id));
                var nextDiv = d.nextSibling;
                button.setAttribute("aria-expanded", true);
                nextDiv.classList.add("fr-collapse--expanded");
            }
            else {
                var d = document.getElementById("".concat(button.id));
                var nextDiv = d.nextSibling;
                button.setAttribute("aria-expanded", false);
                nextDiv.classList.remove("fr-collapse--expanded");
            }
        });
    };
    var navMenuId = useRef(id || generateID());
    useEffect(function () {
        navMenuId.current = id || generateID();
    }, [id]);
    return (React.createElement("li", { className: _classNames }, megaMenu ? (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "fr-nav__btn", onClick: function (e) { return itExpands(e); }, id: navMenuId.current, "aria-controls": navMenuId.current }, label ? label : children),
        React.createElement("div", { className: "fr-collapse fr-mega-menu", id: navMenuId.current, tabIndex: -1 },
            React.createElement("div", { className: "fr-container fr-container--fluid fr-container-lg" },
                React.createElement("button", { className: "fr-btn--close fr-btn", "aria-controls": navMenuId.current, onClick: function (e) {
                        itExpands(e);
                    } }, "Fermer"),
                React.createElement("div", { className: "fr-grid-row fr-grid-row-lg--gutters" },
                    React.createElement("div", { className: "fr-col-12 fr-col-lg-8 fr-col-offset-lg-4--right fr-mb-4v" }, navItemHeader),
                    navItemBody))))) : (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "fr-nav__btn", onClick: function (e) { return itExpands(e); }, id: navMenuId.current, "aria-controls": navMenuId.current }, label ? label : children),
        React.createElement("div", { className: "fr-collapse fr-menu", id: navMenuId.current, tabIndex: -1 },
            React.createElement("ul", { className: "fr-menu__list" }, Children.toArray(navLink).map(function (child, index) { return (React.createElement("li", { key: index, onClick: function (e) { return getActive(e); } }, child)); })))))));
};
NavItem.defaultProps = { __TYPE: "NavItem" };
NavItem.propTypes = { __TYPE: PropTypes.string };
export default NavItem;
